var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"partners section"},[_c('div',{staticClass:"partners__container"},[_c('h2',{staticClass:"section__title"},[_vm._v("\n      "+_vm._s(_vm.$t('partners.title'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"partners__list"},[_c('a',{staticClass:"partners__item",style:({
          maxHeight: '48px',
          marginTop: '8px'
        }),attrs:{"href":_vm.getProviderHref('swisscom')}},[_c('ResponsiveImage',{attrs:{"srcset":[
            require('~/assets/images/provider-logos/v7/white/Swisscom.svg')
          ],"alt":"Swisscom","lazy":""}})],1),_vm._v(" "),_c('a',{staticClass:"partners__item",style:({
          maxHeight: '30px'
        }),attrs:{"href":_vm.getProviderHref('salt')}},[_c('ResponsiveImage',{attrs:{"srcset":[
            require('~/assets/images/provider-logos/v7/white/Salt.svg'),
          ],"alt":"Salt","lazy":""}})],1),_vm._v(" "),_c('a',{staticClass:"partners__item",style:({
          maxHeight: '30px'
        }),attrs:{"href":_vm.getProviderHref('wingo')}},[_c('ResponsiveImage',{attrs:{"srcset":[
            require('~/assets/images/provider-logos/v7/white/Wingo.svg'),
          ],"alt":"Wingo","lazy":""}})],1),_vm._v(" "),_c('a',{staticClass:"partners__item",style:({
          maxHeight: '30px'
        }),attrs:{"href":_vm.getProviderHref('yallo')}},[_c('ResponsiveImage',{attrs:{"srcset":[
            require('~/assets/images/provider-logos/v7/white/yallo.svg'),
          ],"alt":"Yallo","lazy":""}})],1),_vm._v(" "),_c('a',{staticClass:"partners__item",style:({
          maxHeight: '30px'
        }),attrs:{"href":_vm.getProviderHref('migros-mobile')}},[_c('ResponsiveImage',{attrs:{"srcset":[require('~/assets/images/provider-logos/v7/white/migros.svg')],"alt":"Migros Mobile","lazy":""}})],1),_vm._v(" "),_c('a',{staticClass:"partners__item",style:({
          maxHeight: '30px'
        }),attrs:{"href":_vm.getProviderHref('quickline')}},[_c('ResponsiveImage',{attrs:{"srcset":[
            require('~/assets/images/provider-logos/v7/white/Quickline.svg'),
          ],"alt":"Quickline","lazy":""}})],1),_vm._v(" "),_c('a',{staticClass:"partners__item",style:({
          maxHeight: '46px'
        }),attrs:{"href":_vm.getProviderHref('talktalk')}},[_c('ResponsiveImage',{attrs:{"srcset":[
            require('~/assets/images/provider-logos/v7/white/TalkTalk.svg'),
          ],"alt":"TalkTalk","lazy":""}})],1),_vm._v(" "),_c('a',{staticClass:"partners__item",style:({
          maxHeight: '30px'
        }),attrs:{"href":_vm.getProviderHref('spusu')}},[_c('ResponsiveImage',{attrs:{"srcset":[
            require('~/assets/images/provider-logos/v7/white/Spusu.svg'),
          ],"alt":"Spusu","lazy":""}})],1),_vm._v(" "),_c('a',{staticClass:"partners__item",style:({
          maxHeight: '30px'
        }),attrs:{"href":_vm.getProviderHref('mtel')}},[_c('ResponsiveImage',{attrs:{"srcset":[
            require('~/assets/images/provider-logos/v7/white/Mtel.svg'),
          ],"alt":"Mtel","lazy":""}})],1)])])])
}]

export { render, staticRenderFns }